import {
  useCreateDealForMembershipPaidMutation,
  useCreateDealForOrderPaidMutation,
} from '@/redux/rtk';
import { useMemo } from 'react';

export const useDeals = () => {
  const [createDealForOrderPaid, createDealForOrderPaidState] =
    useCreateDealForOrderPaidMutation();
  const [createDealForMembershipPaid, createDealForMembershipPaidState] =
    useCreateDealForMembershipPaidMutation();

  return useMemo(
    () => ({
      createDealForOrderPaid,
      createDealForOrderPaidState,
      createDealForMembershipPaid,
      createDealForMembershipPaidState,
    }),
    [
      createDealForOrderPaid,
      createDealForOrderPaidState,
      createDealForMembershipPaid,
      createDealForMembershipPaidState,
    ]
  );
};
